export const getCookie = (name: string): string | null => {
    const match = document.cookie.match(new RegExp(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`));
    return match ? match[2] : null;
};
